(function() {(window.nunjucksPrecompiled = window.nunjucksPrecompiled || {})["admin/main/includes/modals/_blank_modal.html"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = 0;
var colno = 0;
var output = "";
try {
var parentTemplate = null;
output += "<div class=\"comet-modal-overlay js-comet-modal-overlay comet-modal-overlay--backdrop\" role=\"dialog\"></div>\n<div class=\"comet-modal js-comet-modal\" role=\"document\" tabindex=\"0\">\n    <div id=modal-default class=\"comet-modal__inner\">\n        <div class=\"comet-modal__header comet-long-form-text\">\n            <h3 class=\"comet-modal__header-content\">";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "modalHeader"), env.opts.autoescape);
output += "</h3>\n        </div>\n        <div class=\"comet-modal__content comet-long-form-text\">\n            ";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "modalText"), env.opts.autoescape);
output += "\n        </div>\n        <div class=\"comet-modal__footer\">\n            <div class=\"comet-modal__button-row\">\n                ";
if(runtime.contextOrFrameLookup(context, frame, "showCancelButton")) {
output += "\n                    <button class=\"comet-button comet-button--ghost comet-modal__button comet-modal__button--cancel js-comet-modal__close-button\">Cancel</button>j\n                ";
;
}
output += "\n                ";
if(runtime.contextOrFrameLookup(context, frame, "showOKButton")) {
output += "\n                    <button class=\"comet-button comet-button--primary comet-modal__button comet-modal__button--confirm\">OK</button>\n                ";
;
}
output += "\n            </div>\n        </div>\n    </div>\n</div>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();

define("apps/admin/templates/includes/modals/_blank_modal", function(){});

